

// import React, { useState, useEffect } from "react";
// import { FaBars, FaTimes } from "react-icons/fa";
// import a1 from "./a1.png";
// import "./style.css";
// import { Link, useLocation } from "react-router-dom";

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [showHeader, setShowHeader] = useState(true);
//   const [lastScroll, setLastScroll] = useState(0);
//   const [scrolled, setScrolled] = useState(false);
//   const [bgColor, setBgColor] = useState("transparent");
//   const [textColor, setTextColor] = useState("white");
//   const location = useLocation();

//   const toggleMenu = () => {
//     setMenuOpen(prev => !prev);
//     // if closing, also close sub‑dropdown
//     if (menuOpen) setDropdownOpen(false);
//   };
//   const toggleDropdown = (e) => {
//     e.preventDefault();
//     setDropdownOpen(prev => !prev);
//   };

//     // Scroll listener
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 120) setScrolled(true);
//       else setScrolled(false);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const isMobile = window.innerWidth <= 768;


//     useEffect(() => {
//   if (isMobile) {
//     // Always solid on mobile
//     setBgColor("transparent");
//     setTextColor("#fff");
//          if (scrolled) {
//            setBgColor("#fff");
//          }
//   } else {
//     // Desktop behavior
//     if (location.pathname === "/") {
//       // Home page
//       if (scrolled) {
//         setBgColor("#fff");
//         setTextColor("rgba(0, 0, 0, 0.85)");
//       } else {
//         setBgColor("transparent");
//         setTextColor("#fff");
//       }
//     } else {
//       // Other pages
//       setBgColor("#fff");
//       setTextColor("#000");
//     }
//   }
// }, [location, scrolled, isMobile]);

//   return (
//     <header className={`modern-header ${showHeader ? "visible" : "hidden"}`}  style={{
//         background: bgColor,
//         color: textColor,
//           boxShadow: scrolled
//       ? "0 2px 10px rgba(0, 0, 0, 0.1)" // subtle shadow when scrolled
//       : "none",
//         transition: "background 0.3s ease, color 0.3s ease",
//       }}
//     >
//       <div className="nav-container">
//         <div className="logo">
//           <img src={a1} alt="InfoSight Logo" />
//         </div>

//         <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
//           <ul>
//             <li><a href="/">HOME</a></li>
//             <li><a href="/about">ABOUT</a></li>

//             <li
//               className="dropdown"
//               onMouseEnter={() => !isMobile && setDropdownOpen(true)}
//               onMouseLeave={() => !isMobile && setDropdownOpen(false)}
//               onClick={(e) => isMobile && toggleDropdown(e)}
//             >
//               <a href="#services">SERVICES</a>
//                     {dropdownOpen && (
//                 <ul className="dropdown-menu">
//                   <li><Link to="/buildingAcoustics">Building Acoustics</Link></li>
//                   <li><Link to="/av">AV</Link></li>
//                   <li><Link to="/it">IT/ICT & Data Centers</Link></li>
//                   <li><Link to="/security-risk">Security Risk Assessment</Link></li>
//                   <li><Link to="/security">Security</Link></li>
//                   <li><Link to="/pm">Project Management</Link></li>
//                 </ul>
//               )}
//             </li>

//             <li><a href="/#">PROJECTS</a></li>
//             <li><a href="/#">CONTACT</a></li>
//           </ul>
//         </nav>

//         <div className="mobile-toggle" onClick={toggleMenu}>
//           {menuOpen ? <FaTimes /> : <FaBars />}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;



import React, { useState, useEffect } from "react";
import { FaBars, FaTimes,  FaBuilding, FaVideo, FaNetworkWired, FaShieldAlt, FaLock, FaTasks, FaQuestionCircle, FaLeaf } from "react-icons/fa";

import { Link, useLocation } from "react-router-dom";
import a1 from "./a1.png";
import "./style.css";
import axios from "axios";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [bgColor, setBgColor] = useState("transparent");
  const [textColor, setTextColor] = useState("white");
    const [serviceMenus, setServiceMenus] = useState([]);

  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  const isMobile = window.innerWidth <= 768;


  const iconMapping = {
  "ACOUSTICS": <FaBuilding />,
  "SECURITY": <FaLock />,
  "SRA": <FaShieldAlt />,
  "IT/ICT": <FaNetworkWired />,
  "AV": <FaVideo />,
  "IBMS": <FaNetworkWired />,
  "SUSTAINABILITY & GREEN BUILDING": <FaLeaf />,
  "PROJECT MANAGEMENT": <FaTasks />,
};

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 120) setScrolled(true);
      else setScrolled(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Change navbar background and text based on route and scroll
  // useEffect(() => {
  //   if (location.pathname === "/") {
  //     // Home page
  //     if (scrolled) {
  //       setBgColor("#fff");
  //       setTextColor("rgba(0, 0, 0, 0.85)");
  //     } else {
  //       setBgColor("transparent");
  //       setTextColor("#fff");
  //     }
  //   } else {
  //     // Other pages
  //     setBgColor("#fff");
  //     setTextColor("#000");
  //   }
  // }, [location, scrolled]);


    // Fetch the services menu dynamically from the API
  useEffect(() => {
    const fetchServiceMenus = async () => {
      try {
        const response = await axios.get("https://api.info-sight.net/api/services-menus");
        setServiceMenus(response.data);
      } catch (error) {
        console.error("Error fetching service menus:", error);
      }
    };

    fetchServiceMenus();
  }, []);

  useEffect(() => {
  if (isMobile) {
    // Always solid on mobile
    setBgColor("transparent");
    setTextColor("#fff");
         if (scrolled) {
           setBgColor("#fff");
         }
  } else {
    // Desktop behavior
    if (location.pathname === "/") {
      // Home page
      if (scrolled) {
        setBgColor("#fff");
        setTextColor("rgba(0, 0, 0, 0.85)");
      } else {
        setBgColor("transparent");
        setTextColor("#fff");
      }
    } else {
      // Other pages
      setBgColor("#fff");
      setTextColor("#000");
    }
  }
}, [location, scrolled, isMobile]);


  // useEffect(() => {
  //   if (location.pathname === "/") {
  //     document.body.classList.add("home-page");
  //   } else {
  //     document.body.classList.remove("home-page");
  //   }
  // }, [location.pathname]);


  useEffect(() => {
  const isHome = location.pathname === "/";

  if (scrolled) {
    // Whenever user scrolls → remove home-page
    document.body.classList.remove("home-page");
  } else {
    // Only add home-page when on Home AND not scrolled
    if (isHome) {
      document.body.classList.add("home-page");
    } else {
      document.body.classList.remove("home-page");
    }
  }
}, [location.pathname, scrolled]);



  return (
    <header
      className="header"
      style={{
        background: bgColor,
        color: textColor,
           boxShadow:
      location.pathname === "/" 
        ? scrolled 
          ? "0 2px 10px rgba(0, 0, 0, 0.1)" 
          : "none"
        : "0 2px 10px rgba(0, 0, 0, 0.1)", // always shadow on other pages
        transition: "background 0.3s ease, color 0.3s ease",
        marginTop: location.pathname === "/" ? (scrolled ? "0px" : "20px") : "0px",
           padding: scrolled ? "15px 0" : "25px 0"
      }}
    >
      <div className="container header-content">
        {/* Logo */}
        <div className="logo">
          <img src={a1} alt="MyConsultants Logo" />
        </div>

        {/* Navigation */}
        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          {menuOpen && (
            <div className="nav_logo">
              <img src={a1} alt="MyConsultants Logo" />
            </div>
          )}

          <ul>
            <li>
              <Link style={{ color: textColor }} to="/">Home</Link>
            </li>
            <li>
              <Link style={{ color: textColor }} to="/about">About Us</Link>
            </li>

            {/* Services Dropdown */}
            <li
              className="dropdown"
              onMouseEnter={() => !isMobile && setDropdownOpen(true)}
              onMouseLeave={() => !isMobile && setDropdownOpen(false)}
            >
              <a
                href="#services"
                style={{ color: textColor }}
                onClick={(e) => isMobile && toggleDropdown(e)}
              >
                Services
              </a>

         {/* {dropdownOpen && (
  <ul className="dropdown-menu">
    <li>
      <Link to="/buildingAcoustics">
        <FaBuilding className="menu-icon" /> Building Acoustics
      </Link>
    </li>
    <li>
      <Link to="/security">
        <FaLock className="menu-icon" />  Security 
      </Link>
    </li>
     <li>
      <Link to="/it">
        <FaNetworkWired className="menu-icon" /> IBMS  Data Centers
      </Link>
    </li>
    <li>
      <Link to="/av">
        <FaVideo className="menu-icon" /> AV Solutions
      </Link>
    </li>
   
    <li>
      <Link to="/security-risk">
        <FaShieldAlt className="menu-icon" /> Security Risk Assessment
      </Link>
    </li>
    
    <li>
      <Link to="/pm">
        <FaTasks className="menu-icon" /> Project Management
      </Link>
    </li>
  </ul>
)} */}

 {dropdownOpen && (
                <ul className="dropdown-menu">
                  {/* Loop through the serviceMenus and display each one */}
{serviceMenus.map((menu) => {

  const cleanSlug = (menu.heading || menu.menu_name)
    ?.toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/\//g, '/');

  return (
    <li key={menu.id}>
      <Link to={`/service/${cleanSlug}`}     style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {iconMapping[menu.menu_name] || <FaQuestionCircle />}
        {menu.menu_name}
      </Link>
    </li>
  );
})}

                </ul>
              )}
            </li>

            <li><Link style={{ color: textColor }} to="/project">Projects</Link></li>
              <li>
              <Link style={{ color: textColor }} to="/careers">Careers</Link>
            </li>
            <li><Link style={{ color: textColor }} to="/contact">Contact</Link></li>

          </ul>
        </nav>

        {/* Mobile Toggle */}
        <div className="mobile-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes color='#d81919ff' /> : <FaBars color='#d81919ff' />}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
